import axios from "axios";
import { AppDispatch } from "../../app/store";
import { getAccessToken } from "../../api/empty.api";
import { setHtmlDocumentStatus, setDocument, setRawEdiDocumentStatus, setRawEdi, setRawEdiErrored, setDocumentName, setDocumentError, setTransactionResendError, setTransactionResendFileName, setTransactionResendFileStatus, setAcknowledgementDocumentStatus, setXmlDocumentStatus } from "./PurchaseOrdersSlice";
import { GetV1PurchaseOrdersAcknowledgementDocumentApiArg, GetV1PurchaseOrdersByTenantIdHtmlDocumentApiArg, GetV1PurchaseOrdersByTenantIdRawEdiDocumentApiArg, GetV1PurchaseOrdersByTenantIdResendDocumentApiArg, GetV1PurchaseOrdersByTenantIdXmlDocumentApiArg } from "../../api/purchaseOrders.api";

// Generic document fetcher configuration
interface DocumentFetchConfig {
  endpoint: string;
  params: Record<string, any>;
  statusDispatcher: (data: any) => any;
  includeDocumentName?: boolean;
}

// Generic function to fetch documents
const fetchDocument = (config: DocumentFetchConfig) =>
  async (dispatch: AppDispatch): Promise<void> => {
    const { endpoint, params, statusDispatcher, includeDocumentName } = config;
    const url = `${process.env.REACT_APP_EDI_PORTAL_API_ENDPOINT}${endpoint}`;
    const token = await getAccessToken();
    
    if (token) {
      axios({
        method: 'get',
        url: url,
        headers: { Authorization: `Bearer ${token}` },
        params: params
      })
      .then(response => {
        if (response && response.data) {
          dispatch(statusDispatcher(response.data));
          if (response.data.wasSuccessful === true) {
            dispatch(setDocument(response.data.data as string));
            if (includeDocumentName !== false) {
              dispatch(setDocumentName(response.data.dataDescription as string));
            }
          }
        }
      })
      .catch(ex => {
        dispatch(setDocumentError(ex));
      });
    }
  };


/** OBSOLETE! **/
// This function can NOT be used as is.  The backend has removed the endpoint since it was no longer functional.
export const getPurchaseOrderRawEDI = (tenantId: string, fileName: string) => 
async (dispatch: AppDispatch): Promise<void> =>{
    // We don't want to cache the response like the autogenerated queries will, so manually get the file.
    let url = `${process.env.REACT_APP_EDI_PORTAL_API_ENDPOINT}/v1/purchase-orders/${tenantId}/file`;
      const token = await getAccessToken();
      if (token) {
        axios({
          method: 'get',
          url: url as string,
          headers: { Authorization: `Bearer ${token}` },
          params: {
            fileId: fileName ? fileName : ''
          }
        })
        .then (response => {
            dispatch(setRawEdi(response.data as string));
        })
        .catch(ex => {
            dispatch(setRawEdiErrored(true));
        })
      }
};

export const getRawEDIDocument = (options: GetV1PurchaseOrdersByTenantIdRawEdiDocumentApiArg) =>
  fetchDocument({
    endpoint: `/v1/purchase-orders/${options.tenantId}/raw-edi-document`,
    params: {
      tenantId: options.tenantId,
      transactionId: options.transactionId,
      internalTransactionId: options.internalTransactionId
    },
    statusDispatcher: setRawEdiDocumentStatus
  });

export const getXmlDocument = (options: GetV1PurchaseOrdersByTenantIdXmlDocumentApiArg) =>
  fetchDocument({
    endpoint: `/v1/purchase-orders/${options.tenantId}/xml-document`,
    params: {
      tenantId: options.tenantId,
      transactionId: options.transactionId,
      internalTransactionId: options.internalTransactionId
    },
    statusDispatcher: setXmlDocumentStatus
  });

export const getHtmlDocument = (options: GetV1PurchaseOrdersByTenantIdHtmlDocumentApiArg) =>
  fetchDocument({
    endpoint: `/v1/purchase-orders/${options.tenantId}/html-document`,
    params: {
      tenantId: options.tenantId,
      transactionId: options.transactionId,
      internalTransactionId: options.internalTransactionId
    },
    statusDispatcher: setHtmlDocumentStatus
  });

export const getAcknowledgementDocument = (args: GetV1PurchaseOrdersAcknowledgementDocumentApiArg) =>
  fetchDocument({
    endpoint: `/v1/purchase-orders/acknowledgement-document`,
    params: {
      internalTransactionId: args.internalTransactionId
    },
    statusDispatcher: setAcknowledgementDocumentStatus,
    includeDocumentName: false
  });

export const resendDocument = (options: GetV1PurchaseOrdersByTenantIdResendDocumentApiArg) =>
  async (dispatch: AppDispatch): Promise<void> => {
    let url = `${process.env.REACT_APP_EDI_PORTAL_API_ENDPOINT}/v1/purchase-orders/${options.tenantId}/resend-document`;
  const token = await getAccessToken();
      if (token) {
        axios({
          method: 'get',
          url: url as string,
          headers: { Authorization: `Bearer ${token}` },
          params: {
            tenantId: options.tenantId,
            transactionId: options.transactionId,
            internalTransactionId: options.internalTransactionId
          }
        })
        .then (response => {
          if (response && response.data) {
            dispatch(setTransactionResendFileStatus(response.data));
          }
      })
      .catch(ex => {
        dispatch(setTransactionResendError(ex));
      })
    }
  };
